<script>
  import { onDestroy, onMount } from "svelte";
  import * as PropTypes from "prop-types";
  const { checkPropTypes, string, bool, object } = PropTypes;
  import RangeSlider from "@/components/atoms/RangeSlider.svelte";
  import SvgWrapper from "@/components/atoms/SvgWrapper.svelte";
  import SvgPlay from "$assets/svg/play.svg?src";
  import SvgPause from "$assets/svg/pause.svg?src";

  export let item,
    rangeClass,
    audioClass = "",
    autoplay = true,
    shouldRunInLoop = true,
    preload = "metadata";

  const propTypes = {
    item: object,
    audioClass: string,
    rangeClass: string,
    autoplay: bool,
    shouldRunInLoop: bool,
    preload: string,
  };

  let audioElement,
    audioSrc,
    isSeeking = false;

  let duration, currentTime, paused, muted, seekValue;

  $: audioSrc = item?.audioMeta?.resourceUrl;

  $: if (!isSeeking) {
    seekValue = currentTime;
  }

  const playAudio = () => {
    if (audioElement && paused) {
      const promise = audioElement.play();
      if (promise) {
        promise.catch(() => {
          pauseAudio();
        });
      }
    }
  };
  const pauseAudio = () => {
    if (audioElement && !paused) {
      const promise = audioElement.pause();
      if (promise) {
        promise.catch(() => {});
      }
    }
  };

  const toggleAudioPlaying = () => {
    if (audioElement && paused) {
      muted = !!item.isMuted;
      playAudio();
    } else {
      pauseAudio();
    }
  };

  const handleSeekInput = () => {
    isSeeking = true;
  };

  const handleSeekChange = (value) => {
    isSeeking = false;
    currentTime = value;
  };

  const getTime = (duration) => {
    let mins = Math.floor(duration / 60);
    let secs = Math.round(duration % 60);
    mins = mins < 10 ? `0${mins}` : `${mins}`;
    secs = secs < 10 ? `0${secs}` : `${secs}`;
    return `${mins}:${secs}`;
  };

  const loadedMetadata = () => {
    currentTime = 0;
    paused = audioElement.paused;
    duration = audioElement.duration;
    muted = item.isMuted || audioElement?.muted;
  };

  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "AudioItem");
    if (audioElement) {
      audioElement.addEventListener("loadedmetadata", loadedMetadata);
      window.addEventListener("blur", pauseAudio);
    }
  });

  onDestroy(() => {
    if (audioElement) {
      audioElement.removeEventListener("loadedmetadata", loadedMetadata);
      window.removeEventListener("blur", pauseAudio);
    }
  });
</script>

<div class={`flex w-full ${audioClass}`}>
  <audio
    bind:this={audioElement}
    bind:duration
    bind:currentTime
    bind:paused
    bind:muted
    {autoplay}
    {preload}
    src={audioSrc}
    loop={shouldRunInLoop}
    class="lazyload"
  />
  <button on:click={toggleAudioPlaying} id="audio-player" class="mr-xs" data-testId={paused ? 'play-button' : 'pause-button'}>
    <SvgWrapper
      className={`h-mmd w-mmd`}
      svg={paused ? SvgPlay : SvgPause}
    />
  </button>
  <RangeSlider
    onInput={handleSeekInput}
    onChange={handleSeekChange}
    value={seekValue}
    max={duration}
    min={0}
    step="any"
    {rangeClass}
  />
  <span class="mx-xs">{getTime(duration || 0)}</span>
</div>
